import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-list-element',
  templateUrl: './list-element.component.html',
  styleUrls: ['./list-element.component.scss']
})
export class ListElementComponent {
  @Input() iconOrIndex = '';
  @Input() icon = false;
  @Input() text = '';
  @Input() color = '#000';
}
